import React from 'react';

interface IFollowsCalloutProps {
  actionText: string;
  description: string;
  actionURL: string;
}

export default class FollowsCallout extends React.Component<IFollowsCalloutProps, null> {
  render() {
    return (
      <div className="feed-customize__callout">
        <p>{this.props.description}</p>
        <p>
          <a href={this.props.actionURL}>
            {this.props.actionText}
          </a>
        </p>
      </div>
    );
  }
}
